import { useQueryClient } from "@tanstack/react-query";
import { $journalApi } from "@entities/journal/fetch/fetch-client.ts";
import {
  type TitleJournalMutateOptions,
  withTitleJournalInvalidation,
} from "./invalidate-title-journal-queries";

interface IUseReviewerApprove {
  titleId: string;
}

export function useReviewerApprove({ titleId }: IUseReviewerApprove) {
  const queryClient = useQueryClient();
  const resultLegacyToken = localStorage.getItem("token");
  const mutation = $journalApi.useMutation(
    "post",
    "/api/v1/journals/title/{titleId}/reviewerApprove",
  );

  return {
    ...mutation,
    mutate: (mutateOptions?: TitleJournalMutateOptions) => {
      mutation.mutate(
        {
          params: { path: { titleId }, header: { "X-Auth": resultLegacyToken || '' } },
        },
        withTitleJournalInvalidation(queryClient, titleId, mutateOptions),
      );
    },
  };
}
